import { CLEAR_MENU_DATA, SET_MENU_DATA } from "../action-types";

const initialState = {
  menuData: null,
  menuLoading: false,
};

export default function menuReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MENU_DATA:
      return { ...state, menuData: action.payload };

    case CLEAR_MENU_DATA:
      return { ...state, menuData: null };

    case "MENU_LOADING_START":
      return { ...state, menuLoading: true };

    case "MENU_LOADING_END":
      return { ...state, menuLoading: false };

    default:
      return state;
  }
}
